import React, { useState } from 'react';
import styles from '../../ResourceShare.module.scss';
import { PillTabs } from 'new/elements/PillTabs';

export type ResourceType = (typeof resourceOptions)[number]['value'];
interface ResourceSelectionProps {
  onChange: (value: ResourceType) => void;
}

const resourceOptions = [
  {
    label: 'Flows',
    value: 'flow',
  },
  {
    label: 'Nexsets',
    value: 'nexset',
  },
  {
    label: 'Sources',
    value: 'source',
  },
  {
    label: 'Destinations',
    value: 'destination',
  },
];

export function ResourceSelection(props: ResourceSelectionProps) {
  const { onChange } = props;
  const [selectedResource, setSelectedResource] = useState('flow');

  const handleChange = (value) => {
    setSelectedResource(value);
    onChange(value);
  };

  return (
    <div className={styles.resource_types}>
      <PillTabs
        tabs={resourceOptions}
        onSelectionChange={handleChange}
        selected={selectedResource}
      />
    </div>
  );
}
